import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { Link } from "react-router-dom";


function ShopArea() {
  const {
    data: blogs,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["blogs"],
    queryFn: async () => {
      const { data } = await axios.get(
        `https://be-staging.obigin.com/content/blogs`
      );
      return data.data;
    },
  });

  if (isLoading) return <p>Loading blogs...</p>;
  if (isError || !blogs) return <p>Failed to load blogs.</p>;

  return (
    <section className="shop-area pt-120 pb-90">
      <div className="container">
        <div className="row">
          {blogs.map((blog) => (
            <div className="col-lg-4 col-sm-6" key={blog.slug}>
              <div className="accessories-item text-center mb-80">
                <div className="accessories-thumb mb-30 featured-game-item">
                  <Link to={`/blogs/${blog._id}`}>
                    <img
                      src={blog.coverImage || "/assets/img/product/shop_item01.jpg"}
                      alt={blog.title}
                      style={{ height: "250px", objectFit: "cover", width: "100%" }}
                    />
                  </Link>
                </div>
                <div className="accessories-content">
                  <h5>
                    <Link to={`/blogs/${blog._id}`}>{blog.title}</Link>
                  </h5>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ShopArea;
